import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from 'src/app/Services/authentication.service';
import { RedirectService } from '../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _auth: AuthenticationService,
    private _redirect: RedirectService
  ) {}

  canActivate(): boolean {
    if (this._auth.LocalLoginCheck()) {
      this._auth.LocalLogin();
      return true;
    }

    if (!this._auth.currentUserValue) {
      this._redirect.ToAuthServerLoginPage();
      return false;
    }

    return true;
  }
}
